import { cn } from '@/utils/ui-utils';

type Props = {
  value: number | null | undefined;
  unit?: string;
  className?: string;
  unitClassName?: string;
  sort?: React.ReactNode;
};

export const DeltaUnit = ({ value, unit, className, unitClassName, sort }: Props) => {
  if (value === undefined || value === null) {
    return (
      <div className={cn(className)}>
        <span className='text-muted-foreground'>—</span>
      </div>
    );
  }

  return (
    <div
      className={cn(
        `flex h-6 items-center rounded-full border p-1 px-2 text-xs font-semibold
        ${value < 0 ? 'text-semantic-error' : value === 0 ? 'text-primary' : 'text-semantic-success'}`,
        sort ? 'hover:bg-muted' : '',
        className,
      )}
    >
      <span>{typeof value === 'number' ? value.toLocaleString('sv-SE') : value}</span>
      <span className={cn(unitClassName, 'ml-0.5')}>{unit}</span>
      {sort && <span className='ml-0.5'>{sort}</span>}
    </div>
  );
};
